/*
 * yodaSiteComponents registry entries for this microsite.
 *
 * Only the externalized shell set (header/footer/sliders, PM-312) — it comes
 * from the shared fragment in yoda-app-shell so every microsite carries the
 * identical definition. Add page-level entries here if this microsite starts
 * consuming its own federated components.
 */
const {
    getExternalizedShellRegistry,
} = require('yoda-app-shell/lib/mfe/externalMfComponents');

const yodaSiteComponents = {
    BackgroundClose: {
        importFn: () => import('yodaSiteComponents/BackgroundClose'),
        path: 'yodaSiteComponents/BackgroundClose',
        type: 'functional',
        isSSR: false,
    },
    DataSizeChart: {
        importFn: () => import('yodaSiteComponents/DataSizeChart'),
        path: 'yodaSiteComponents/DataSizeChart',
        type: 'class',
        isSSR: false,
    },
    ...getExternalizedShellRegistry(),
};

module.exports = { yodaSiteComponents };
